export const EasyBookingValidationFailedReasonType = {
    /** 해외직배송 상품 통관처리를 위한 고유식별정보 수집 및 제공 동의에 체크해 주세요. */
    NOT_AGREED_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_PROVIDE_TO_MERCHANT:
        'NOT_AGREED_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_PROVIDE_TO_MERCHANT',
    DUPLICATE_PRODUCT_COUPON: 'DUPLICATE_PRODUCT_COUPON',
    // 카페 자전거래 불가
    CAFE_MERCHANT_IDENTICAL_TO_CUSTOMER: 'CAFE_MERCHANT_IDENTICAL_TO_CUSTOMER',
    FLEAMARKET_MERCHANT_IDENTICAL_TO_CUSTOMER: 'FLEAMARKET_MERCHANT_IDENTICAL_TO_CUSTOMER',
    EXCEED_CAFE_MERCHANT_SIZE: 'EXCEED_CAFE_MERCHANT_SIZE',
    INVALID_EASYBOOKING_POINT_USAGE: 'INVALID_EASYBOOKING_POINT_USAGE',
    INVALID_EASYBOOKING_COUPON_USAGE: 'INVALID_EASYBOOKING_COUPON_USAGE',
    INVALID_EASYBOOKING_CARD_COMPANY_CODE: 'INVALID_EASYBOOKING_CARD_COMPANY_CODE',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    /** 상품 validation 실패 */
    ORDER_SHEET_ITEM_LIST_CHECK_FAILED: 'ORDER_SHEET_ITEM_LIST_CHECK_FAILED',
    PRODUCT_NULL_URL: 'PRODUCT_NULL_URL',
    PRODUCT_NEGATIVE_SALE_PRICE: 'PRODUCT_NEGATIVE_SALE_PRICE',
    PRODUCT_NULL_SALE_PRICE: 'PRODUCT_NULL_SALE_PRICE',
    PRODUCT_NOT_ON_SALE_STATUS_TYPE: 'PRODUCT_NOT_ON_SALE_STATUS_TYPE',
    PRODUCT_NONEXISTENT: 'PRODUCT_NONEXISTENT',
    PRODUCT_NEW_OPTION_ITEMS_CREATED: 'PRODUCT_NEW_OPTION_ITEMS_CREATED',
    PRODUCT_NONEXISTENT_OPTION_ITEM_VALUE: 'PRODUCT_NONEXISTENT_OPTION_ITEM_VALUE',
    PRODUCT_NULL_OPTION_ITEM_NAME: 'PRODUCT_NULL_OPTION_ITEM_NAME',
    PRODUCT_OPTION_ITEM_NAME_EXCEEDING_LIMIT_LENGTH: 'PRODUCT_OPTION_ITEM_NAME_EXCEEDING_LIMIT_LENGTH',
    PRODUCT_OPTION_ITEM_ID_EXCEEDING_LIMIT_LENGTH: 'PRODUCT_OPTION_ITEM_ID_EXCEEDING_LIMIT_LENGTH',
    PRODUCT_OPTION_ITEM_ID_CONTAINING_BLANKS: 'PRODUCT_OPTION_ITEM_ID_CONTAINING_BLANKS',
    PRODUCT_OPTION_ITEM_ID_CONTAINING_KOREAN_CHARACTERS: 'PRODUCT_OPTION_ITEM_ID_CONTAINING_KOREAN_CHARACTERS',
    PRODUCT_OPTION_ITEM_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS:
        'PRODUCT_OPTION_ITEM_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS',
    PRODUCT_NULL_OPTION_ITEM_TEXT: 'PRODUCT_NULL_OPTION_ITEM_TEXT',
    PRODUCT_OPTION_ITEM_TEXT_EXCEEDING_LIMIT_LENGTH: 'PRODUCT_OPTION_ITEM_TEXT_EXCEEDING_LIMIT_LENGTH',
    PRODUCT_CHANGED_OPTION_ITEM_VALUE_TEXT: 'PRODUCT_CHANGED_OPTION_ITEM_VALUE_TEXT',
    PRODUCT_NONEXISTENT_COMBINATION: 'PRODUCT_NONEXISTENT_COMBINATION',
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH:
        'PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH',
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_BLANKS:
        'PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_BLANKS',
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS:
        'PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS',
    PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS:
        'PRODUCT_MERCHANT_OPTION_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS',
    PRODUCT_NEGATIVE_COMBINATION_STOCK_QUANTITY: 'PRODUCT_NEGATIVE_COMBINATION_STOCK_QUANTITY',
    PRODUCT_ZERO_COMBINATION_STOCK_QUANTITY: 'PRODUCT_ZERO_COMBINATION_STOCK_QUANTITY',
    PRODUCT_INSUFFICIENT_COMBINATION_STOCK_QUANTITY: 'PRODUCT_INSUFFICIENT_COMBINATION_STOCK_QUANTITY',
    PRODUCT_NULL_COMBINATION_OPTION_NAME: 'PRODUCT_NULL_COMBINATION_OPTION_NAME',
    PRODUCT_COMBINATION_OPTION_NAME_EXCEEDING_LIMIT_LENGTH: 'PRODUCT_COMBINATION_OPTION_NAME_EXCEEDING_LIMIT_LENGTH',
    PRODUCT_COMBINATION_OPTION_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS:
        'PRODUCT_COMBINATION_OPTION_ID_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS',
    PRODUCT_COMBINATION_OPTION_ID_CONTAINING_KOREAN_CHARACTERS:
        'PRODUCT_COMBINATION_OPTION_ID_CONTAINING_KOREAN_CHARACTERS',
    PRODUCT_COMBINATION_OPTION_ID_CONTAINING_BLANKS: 'PRODUCT_COMBINATION_OPTION_ID_CONTAINING_BLANKS',
    PRODUCT_CHANGED_COMBINATION_OPTIONS: 'PRODUCT_CHANGED_COMBINATION_OPTIONS',
    PRODUCT_NEGATIVE_STOCK_QUANTITY: 'PRODUCT_NEGATIVE_STOCK_QUANTITY',
    PRODUCT_ZERO_STOCK_QUANTITY: 'PRODUCT_ZERO_STOCK_QUANTITY',
    PRODUCT_INSUFFICIENT_STOCK_QUANTITY: 'PRODUCT_INSUFFICIENT_STOCK_QUANTITY',
    PRODUCT_SOLD_OUT_STATUS_TYPE: 'PRODUCT_SOLD_OUT_STATUS_TYPE',
    PRODUCT_MERCHANT_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH: 'PRODUCT_MERCHANT_MANAGEMENT_CODE_EXCEEDING_LIMIT_LENGTH',
    PRODUCT_EMPTY_MERCHANT_MANAGEMENT_CODE: 'PRODUCT_EMPTY_MERCHANT_MANAGEMENT_CODE',
    PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_BLANKS: 'PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_BLANKS',
    PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS:
        'PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_KOREAN_CHARACTERS',
    PRODUCT_BLANK_NAME: 'PRODUCT_BLANK_NAME',
    PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS:
        'PRODUCT_MERCHANT_MANAGEMENT_CODE_CONTAINING_FORBIDDEN_SPECIAL_CHARACTERS',
    PRODUCT_NULL_DELIVERY_POLICY: 'PRODUCT_NULL_DELIVERY_POLICY',
    PRODUCT_NULL_DELIVERY_FEE_CLASS_TYPE: 'PRODUCT_NULL_DELIVERY_FEE_CLASS_TYPE',
    PRODUCT_NULL_DELIVERY_FEE_PAY_TYPE: 'PRODUCT_NULL_DELIVERY_FEE_PAY_TYPE',
    PRODUCT_NULL_DELIVERY_BASE_FEE: 'PRODUCT_NULL_DELIVERY_BASE_FEE',
    PRODUCT_NEGATIVE_DELIVERY_BASE_FEE: 'PRODUCT_NEGATIVE_DELIVERY_BASE_FEE',
    PRODUCT_DELIVERY_BASE_FEE_GREAT_THAN_MAX_LIMIT: 'PRODUCT_DELIVERY_BASE_FEE_GREAT_THAN_MAX_LIMIT',
    PRODUCT_ZERO_DELIVERY_BASE_FEE: 'PRODUCT_ZERO_DELIVERY_BASE_FEE',
    PRODUCT_NULL_FREE_CONDITIONAL_AMOUNT: 'PRODUCT_NULL_FREE_CONDITIONAL_AMOUNT',
    PRODUCT_NEGATIVE_DELIVERY_AREA2_EXTRA_FEE: 'PRODUCT_NEGATIVE_DELIVERY_AREA2_EXTRA_FEE',
    PRODUCT_DELIVERY_AREA2_EXTRA_FEE_GREAT_THAN_MAX_LIMIT: 'PRODUCT_DELIVERY_AREA2_EXTRA_FEE_GREAT_THAN_MAX_LIMIT',
    EXIST_VALID_EASYBOOKING_RESERVATION: 'EXIST_VALID_EASYBOOKING_RESERVATION',
    NO_PAY_METHODS_REGISTERED: 'NO_PAY_METHODS_REGISTERED',
    FDS_FAILED: 'FDS_FAILED',
    NO_AVAILABLE_PAY_METHODS: 'NO_AVAILABLE_PAY_METHODS',
    CARD_EASY_PAY_INVALID_PAY_AMOUNT: 'CARD_EASY_PAY_INVALID_PAY_AMOUNT',
    RECHARGE_POINT_UNAVAILABLE: 'RECHARGE_POINT_UNAVAILABLE',
    /** 예약/로컬페이 > N/A (현재 정의되지 않은 코드를 플레이스에서 전달 또는 코드 미응답 시) */
    EASYBOOKING_CHECK_STOCK_ETC_ERROR: 'EASYBOOKING_CHECK_STOCK_ETC_ERROR',
    /**
     * - 상품정보변경 (삭제된 슬롯)
     * - 상품 스케줄 정보변경
     * - 미오픈 상품 / 마감 상품
     */
    EASYBOOKING_SLOT_INVALID_SELECTION: 'EASYBOOKING_SLOT_INVALID_SELECTION',
    /** 예약/로컬페이 > 배송불가  */
    EASYBOOKING_CHECK_STOCK_SHIPPING_INVALID: 'EASYBOOKING_CHECK_STOCK_SHIPPING_INVALID',
    /**
     * 예약 / 로컬페이
     * - 대행사 요청 실패
     * - 응답시간 초과
     * - 결제상태 오류
     */
    EASYBOOKING_CHECK_STOCK_PAYMENT_ERROR: 'EASYBOOKING_CHECK_STOCK_PAYMENT_ERROR',
    /** 예약/로컬페이 > 결제 중복  */
    EASYBOOKING_CHECK_STOCK_PAYMENT_DUPLICATED_ERROR: 'EASYBOOKING_CHECK_STOCK_PAYMENT_DUPLICATED_ERROR',
    /** 예약/로컬페이
     * - 결제가능 시간 초과
     * - 좌석선점 시간 초과
     */
    EASYBOOKING_CHECK_STOCK_PAYMENT_DEADLINE_OVER: 'EASYBOOKING_CHECK_STOCK_PAYMENT_DEADLINE_OVER',
    /**
     * 예약/로컬페이
     * - 옵션 최대/최소 예약가능 수량 변경
     * - 옵션 재고 부족
     * - 가격권종 없음
     */
    EASYBOOKING_CHECK_STOCK_OPTION_STALE: 'EASYBOOKING_CHECK_STOCK_OPTION_STALE',
    /**
     * 예약/로컬페이
     * - 옵션정보 변경
     * - 옵션 스케줄 정보 변경
     */
    EASYBOOKING_CHECK_STOCK_OPTION_INVALID_SELECTION: 'EASYBOOKING_CHECK_STOCK_OPTION_INVALID_SELECTION',
    /** 예약/로컬페이
     * - 사용자 정보 없음
     */
    EASYBOOKING_CHECK_STOCK_LOGIN_ERROR: 'EASYBOOKING_CHECK_STOCK_LOGIN_ERROR',
    /**
     * 예약/로컬페이
     * - 좌석점유 오류 /예약인증 정보 없음 / 예약정보 없음 / 스냅샷 정보 없음 / 결제정보 없음 / 파트너사 paid오류 / 좌석예약 생성 호출 오류
     */
    EASYBOOKING_CHECK_STOCK_INTERNAL_SERVER_ERROR: 'EASYBOOKING_CHECK_STOCK_INTERNAL_SERVER_ERROR',
    /**
     * 예약 / 로컬페이
     * - 파트너사 쿠폰검증 오류 / 예약 쿠폰 상태오류 / CRM 오류
     */
    EASYBOOKING_CHECK_STOCK_COUPON_INVALID_TO_USE: 'EASYBOOKING_CHECK_STOCK_COUPON_INVALID_TO_USE',
    /**
     * 예약 / 로컬페이
     * - 업체정보 변경 / 상품정보 변경 (삭제 / 미노출 상품 / 상품 판매 일시중지) / 상품재고 부족 / 좌석 판매 일시 중단 / 상품 노출 종료 / 업체정보 없음 / 상품정보 없음 / 브랜드 정보 없음
     */
    EASYBOOKING_CHECK_STOCK_BOOKING_UNAVAILABLE: 'EASYBOOKING_CHECK_STOCK_BOOKING_UNAVAILABLE',
    /**
     * 예약 / 로컬페이
     * - 환불정보 변경 / 상품정보 변경 (상품 최소/최대 예약수량 변경) / 가격 정보 변경 / 옵션 정보 변경 / 좌석 정보 변경 / 상품/옵션 정보 변경
     */
    EASYBOOKING_CHECK_STOCK_BIZ_ITEM_STALE: 'EASYBOOKING_CHECK_STOCK_BIZ_ITEM_STALE',
    /**
     * 예약
     * - 편의점 택배 중복 예약 케이스
     */
    EASYBOOKING_CHECK_STOCK_BOOKING_DUPLICATED: 'EASYBOOKING_CHECK_STOCK_BOOKING_DUPLICATED',
    /** 외국인 주문서 Default Error */
    ANONYMOUS_DEFAULT_ERROR: 'ANONYMOUS_DEFAULT_ERROR',
    /** 해외카드 사용 기한 만료 */
    EXPIRED_OVERSEA_EASY_CARD: 'EXPIRED_OVERSEA_EASY_CARD',
    /** 외국인 월 결제한도 초과 */
    EXCEED_FOREIGNER_ORDER_PAY_AMOUNT: 'EXCEED_FOREIGNER_ORDER_PAY_AMOUNT',
} as const
